import { Fonts } from "Themes";

const styles = {
    button: {
        width: "40%",
        marginTop: "5%"
    },
    error: {
        ...Fonts.errorFont
    },
    failureContainer: {
        border: "solid 2px red"
    }
}

export default styles;